import React from 'react';
import ZettleSettings from '../ZettleSettings';

/**
 * Zettle section wrapper — mirrors EmailInboxSection/BankConnectionSettings.
 * The whole surface is gated on `payment_integrations` at the rail, and the
 * backend gates it again with requireFeatureStrict; the double check is
 * deliberate, since hiding a tab is convenience and the API is the boundary.
 */
const ZettleSection = ({ companyId }) => (
    <div className="settings-section">
        <ZettleSettings companyId={companyId} />
    </div>
);

export default ZettleSection;
